import { render } from "./SmartControl.vue?vue&type=template&id=8637f60a&scoped=true&lang=pug"
import script from "./SmartControl.vue?vue&type=script&lang=js"
export * from "./SmartControl.vue?vue&type=script&lang=js"

import "./SmartControl.vue?vue&type=style&index=0&id=8637f60a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8637f60a"]])

export default __exports__